import { useEffect, useRef } from 'react';

export const useIsMount = () => {
  const isMountRef = useRef(true);

  useEffect(() => {
    isMountRef.current = false;
  }, []);

  return isMountRef.current;
};

export function useOnChange<T>(onChange: (state: T) => void, state: T, root?: boolean) {
  const isFirstMount = useIsMount();

  useEffect(() => {
    if (!isFirstMount || (isFirstMount && root)) {
      onChange(state);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);
}
